import { isRejectedWithValue, type Middleware } from '@reduxjs/toolkit';
import { reportError } from '@/app/common/utils/errorReporter.ts';

/**
 * RTK Query middleware — zachytí:
 * - 401 Unauthorized → vyšle DOM event, AuthContext reaguje odhlášením
 * - 5xx Server Error → odešle chybu do error loggeru
 */
export const errorMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const payload = action.payload as { status?: number } | undefined;
    const status = payload?.status;

    if (status === 401) {
      window.dispatchEvent(new Event('auth:unauthorized'));
    } else if (typeof status === 'number' && status >= 500) {
      const endpointName = (action.meta as { arg?: { endpointName?: string } } | undefined)?.arg?.endpointName ?? 'unknown';
      reportError(new Error(`API ${status}: ${endpointName}`));
    }
  }
  return next(action);
};
